/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: inherit;
  }
`

export default function MissionIco() {
  return (
    <Fragment>
<svg xmlns="http://www.w3.org/2000/svg" width="79.986" height="79.646" viewBox="0 0 79.986 79.646" css={Color}>
  <g id="그룹_4342" data-name="그룹 4342" transform="translate(-10399 -8390)">
    <g id="그룹_4341" data-name="그룹 4341" transform="translate(10141.161 8008.934)">
      <path id="패스_4463" data-name="패스 4463" d="M279.425,460.708a4.489,4.489,0,0,1-4.289-3.122l-3.169-9.529-10.017-.925a4.529,4.529,0,0,1-3.127-7.328l14.049-17.7,1.855,3.108a26,26,0,0,0,20.146,12.563l4.659.385-16.543,20.834a4.479,4.479,0,0,1-3.527,1.715Zm.46-4.687,0,.007Zm-.817-.131,0,0Zm-15.79-13.657,12.4,1.146,3.933,11.825,10.431-13.138a31.042,31.042,0,0,1-17.62-11.356Z" fill="#20252d"/>
      <path id="패스_4464" data-name="패스 4464" d="M316.244,460.712H316.2a4.49,4.49,0,0,1-3.531-1.721L296.162,438.2l4.524-.478a26.009,26.009,0,0,0,19.822-12.97l1.831-3.216,14.507,18.28a4.529,4.529,0,0,1-3.129,7.325l-10.018.926-3.176,9.551A4.483,4.483,0,0,1,316.244,460.712Zm-.468-4.667,0,.006Zm.815-.158,0,0Zm-11.084-13.961,10.547,13.285,3.932-11.824,12.4-1.148-9.509-11.981A31.065,31.065,0,0,1,305.507,441.926Z" fill="#20252d"/>
      <path id="패스_4465" data-name="패스 4465" d="M296.987,442.866a30.9,30.9,0,1,1,30.9-30.9A30.935,30.935,0,0,1,296.987,442.866Zm0-56.8a25.9,25.9,0,1,0,25.9,25.9A25.93,25.93,0,0,0,296.987,386.066Z" fill="#20252d"/>
      <g id="그룹_4340" data-name="그룹 4340" transform="translate(1)">
        <path id="패스_4457" data-name="패스 4457" d="M292.392,422.007a1.95,1.95,0,0,1-1.376-.569l-8.539-8.366a1.944,1.944,0,0,1,2.752-2.748h0l7.162,6.991,15.022-14.864a1.944,1.944,0,1,1,2.752,2.748h0l-16.395,16.238A1.946,1.946,0,0,1,292.392,422.007Z" transform="translate(-0.063 -0.063)" fill="#20252d"/>
        <path id="패스_4466" data-name="패스 4466" d="M292.329,422.38a2.363,2.363,0,0,1-1.685-.7l-8.536-8.362a2.381,2.381,0,1,1,3.367-3.369l6.851,6.688,14.717-14.562a2.364,2.364,0,0,1,1.681-.7h0a2.381,2.381,0,0,1,1.684,4.064l-16.4,16.24A2.366,2.366,0,0,1,292.329,422.38Zm-8.541-12.252a1.507,1.507,0,0,0-1.065,2.572l8.536,8.362a1.544,1.544,0,0,0,2.139,0l16.4-16.24a1.508,1.508,0,0,0-1.068-2.571h0a1.5,1.5,0,0,0-1.066.443L292.33,417.864l-7.469-7.291A1.512,1.512,0,0,0,283.788,410.128Z" fill="#20252d"/>
      </g>
    </g>
  </g>
</svg>

    </Fragment>
  )
}
   